<p-drawer
  [visible]="isOpen()"
  position="right"
  [style]="{ width: '600px' }"
  [dismissible]="false"
  [modal]="true"
  [showCloseIcon]="false"
  (onHide)="onClose()"
>
  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <div class="header-content">
        @if (termData()) {
          <div class="header-info">
            <h4 class="term-name fw-bold">{{ termData()!.name }}</h4>
            <div class="term-meta">
             
              <p-chip *ngIf="termData()!.categoryName || termData()!.category" [label]="termData()!.categoryName || termData()!.category" styleClass="term-category"></p-chip>
              <p-tag
                *ngIf="termData()!.sensitive"
                value="Sensitive"
                severity="danger"
                class="d-flex align-items-center"
                icon="pi pi-shield"
                [rounded]="true"
                styleClass="sensitive-tag"
              ></p-tag>
            </div>
          </div>
        } @else {
          <div class="header-info">
            <h4 class="term-name fw-bold mb-0">Business Term</h4>
          </div>
        }
      </div>
      <button
        class="close-btn"
        (click)="onClose()"
        pTooltip="Close"
        tooltipPosition="left"
       id="btn-shared-components-business-term-drawer-business-term-drawer-component-1">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <!-- Body -->
  <div class="drawer-body">
    <!-- ELX Loading Overlay -->
    <elx-mat-spinner-overlay
      [isLoading]="isLoading()"
      [overlay]="false"
      [diameter]="60"
      [strokeWidth]="6"
    ></elx-mat-spinner-overlay>

    <!-- Error State -->
    @if (!isLoading() && error()) {
      <div class="error-state">
        <i class="pi pi-exclamation-triangle error-icon"></i>
        <h4>Unable to Load Business Term</h4>
        <p>{{ error() }}</p>
        <button class="retry-btn" (click)="onRetry()" id="btn-shared-components-business-term-drawer-business-term-drawer-component-2">
          <i class="pi pi-refresh"></i>
          Try Again
        </button>
      </div>
    }

    <!-- Content -->
    @else if (!isLoading() && termData()) {
      <p-tabs [value]="activeTab()" (valueChange)="activeTab.set($event)">
        <p-tablist>
          <p-tab value="overview">
            <i class="pi pi-info-circle"></i>
            <span>Overview</span>
          </p-tab>
          <p-tab value="tags">
            <i class="pi pi-tags"></i>
            <span>Tags & Synonyms</span>
          </p-tab>
        </p-tablist>

        <p-tabpanels>
          <!-- Overview Tab -->
          <p-tabpanel value="overview">
            <div class="tab-content">
              <!-- Definition -->
              <div class="info-section">
                <h4 class="section-title">Definition</h4>
                <p class="description-text">
                  {{ termData()!.definition || "No definition provided." }}
                </p>
              </div>

              <!-- Key Information -->
              <div class="info-section">
                <h4 class="section-title">Key Information</h4>
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">Category</span>
                    <span class="info-value">{{
                      termData()!.categoryName || termData()!.category || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Owner</span>
                    <span class="info-value">{{
                      getOwnerName(termData()!.owner)
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Created</span>
                    <span class="info-value">{{
                      termData()!.createdAt | date: "MMM d, yyyy"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">Last Modified</span>
                    <span class="info-value">{{
                      termData()!.lastModifiedAt | date: "MMM d, yyyy"
                    }}</span>
                  </div>
                </div>
              </div>

              <!-- Snippet -->
              @if (termData()!.snippet) {
                <div class="info-section">
                  <h4 class="section-title">Code Snippet</h4>
                  <pre
                    class="snippet-box"
                  ><code>{{ termData()!.snippet }}</code></pre>
                </div>
              }
            </div>
          </p-tabpanel>

          <!-- Tags & Synonyms Tab -->
          <p-tabpanel value="tags">
            <div class="tab-content">
              <!-- Tags -->
              <div class="info-section">
                <h4 class="section-title">Tags</h4>
                <div class="tag-list">
                  @if (termData()!.tags?.length) {
                    @for (tag of termData()!.tags; track tag) {
                      <span class="tag-badge">{{ tag }}</span>
                    }
                  } @else {
                    <p class="empty-text">No tags defined.</p>
                  }
                </div>
              </div>

              <!-- Synonyms -->
              <div class="info-section">
                <h4 class="section-title">Synonyms</h4>
                <div class="tag-list">
                  @if (termData()!.synonyms?.length) {
                    @for (synonym of termData()!.synonyms; track synonym.id) {
                      <span class="synonym-badge">{{ synonym.name }}</span>
                    }
                  } @else {
                    <p class="empty-text">No synonyms defined.</p>
                  }
                </div>
              </div>
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    }
  </div>
</p-drawer>
